/**
 * Global object for storing location data
 */
goog.provide('yext.location.info');

/** @type {boolean} **/
yext.location.info.isBulkEdit;

/** @type {number} **/
yext.location.info.locationId;

/** @type {string} **/
yext.location.info.localeCode;

/** @type {boolean} **/
yext.location.info.isYahooBasicAccount;

/** @type {boolean} **/
yext.location.info.hasOnlyBasicLocations;
